// PrivacyPolicy.js
import React from "react";

function PrivacyPolicy() {
  return (
    <div className="container mx-auto p-8 bg-gray-50 rounded-lg shadow-lg">
      <h1 className="text-4xl font-bold mb-6 text-center text-blue-600">Privacy Policy for Customer</h1>
      <p className="text-lg leading-relaxed mb-6 text-gray-700">
        optxinsights.com is a part of OPTX COMPANY LIMITED recognizes the
        importance of the protection of your personal data. This Privacy Policy
        explains our practices regarding the collection, use or disclosure of
        personal data including other rights of the Data Subjects in accordance
        with the Personal Data Protection Laws.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">Collection of Personal Data</h2>
      <p className="text-lg mt-4 text-gray-700">
        We will collect your personal data that receive directly from you as
        following:
      </p>
      <ul className="list-disc pl-8 text-lg text-gray-700 mt-2">
        <li>Telephone</li>
        <li>Email address</li>
        <li>Facebook Login</li>
        <li>Google Login</li>
      </ul>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">Types of Data Collected</h2>
      <p className="text-lg mt-4 text-gray-700">Personal data such as name, surname, age, date of birth, nationality, identification card, passport, etc.</p>
      <p className="text-lg mt-2 text-gray-700">Contact information such as address, telephone number, e-mail address, etc.</p>
      <p className="text-lg mt-2 text-gray-700">Account details such as username, password, transactions history, etc.</p>
      <p className="text-lg mt-2 text-gray-700">Transaction and Financial information such as purchase history etc.</p>
      <p className="text-lg mt-2 text-gray-700">Technical data such as IP address, Cookie ID, Activity Log, etc.</p>
      <p className="text-lg mt-2 text-gray-700">Other such as photo, video, and other information that is considered personal data under the Personal Data Protection Laws.</p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">Children</h2>
      <p className="text-lg mt-4 text-gray-700">
        If you are under the age of 20 or having legal restrictions, we may
        collect use or disclose your personal data. We require your parents or
        guardian to be aware and provide consent to us or allowed by applicable
        laws. If we become aware that we have collected personal data from
        children without verification of parental consent, we take steps to
        remove that information from our servers.
      </p>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">Storage of Data</h2>
      <p className="text-lg mt-4 text-gray-700">We store your personal data as hard copy and soft copy.</p>
      <p className="text-lg mt-2 text-gray-700">We store your personal data by using the following systems:</p>
      <ul className="list-disc pl-8 text-lg text-gray-700 mt-2">
        <li>Our server in Thailand</li>
        <li>Our server outside of Thailand</li>
        <li>Third-party server service providers in Thailand</li>
        <li>Third-party server service providers outside of Thailand</li>
      </ul>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">Use of Data</h2>
      <p className="text-lg mt-4 text-gray-700">We use the collected data for various purposes:</p>
      <ul className="list-disc pl-8 text-lg text-gray-700 mt-2">
        <li>To create and manage accounts</li>
        <li>To provide products or services</li>
        <li>To improve products, services, or user experiences</li>
        <li>To share and manage information within organization</li>
        <li>To conduct marketing activities and promotions</li>
        <li>To provide after-sales services</li>
        <li>To gather user’s feedback</li>
        <li>To process payments of products or services</li>
        <li>To comply with our Terms and Conditions</li>
        <li>To comply with laws, rules, and regulatory authorities</li>
      </ul>

      <h2 className="text-3xl font-semibold mt-8 text-blue-500">Disclosure of Personal Data</h2>
      <p className="text-lg mt-4 text-gray-700">
        We may disclose your personal data to the following parties in certain
        circumstances:
      </p>
      <h3 className="text-2xl font-semibold mt-4 text-blue-500">Organization</h3>
      <p className="text-lg mt-2 text-gray-700">
        We may disclose your personal data within our organization to provide
        and develop our products or services. We may combine information
        internally across the different products or services covered by this
        Privacy Policy to help us be more relevant and useful to you and others.
      </p>

      <h3 className="text-2xl font-semibold mt-4 text-blue-500">Business Partners</h3>
      <p className="text-lg mt-2 text-gray-700">
        In relation with our business partners, we may disclose certain personal
        data to them in order to coordinate and provide our products or services
        to you and provide necessary information about the availability of our
        products or services.
      </p>
      <h2 className="text-2xl font-semibold mt-4 text-blue-500">Data Retention</h2>
      <p className="text-lg mt-2 text-gray-700">
        We will retain your personal data for as long as necessary during the
        period you are a customer or under relationship with us, or for as long
        as necessary in connection with the purposes set out in this Privacy
        Policy, unless law requires or permits a longer retention period. We
        will erase, destroy or anonymize your personal data when it is no longer
        necessary or when the period lapses.
      </p>

      <h2 className="text-2xl font-semibold mt-4 text-blue-500">Data Subject Rights</h2>
      <p className="text-lg mt-2 text-gray-700">
        Subject to the Personal Data Protection Laws thereof, you may exercise
        any of these rights in the following:
      </p>
      <ul className="list-disc pl-6">
        <li>
          <strong>Withdrawal of consent:</strong> If you have given consent to
          us to collect, use or disclose your personal data, you have the right
          to withdraw such consent at any time unless restricted by law.
        </li>
        <li>
          <strong>Data access:</strong> You have the right to access your
          personal data and request us to make a copy of such data.
        </li>
        <li>
          <strong>Data portability:</strong> You have the right to obtain your
          personal data in a usable format and request us to send or transfer it
          to another data controller.
        </li>
        <li>
          <strong>Objection:</strong> You have the right to object to the
          collection, use or disclosure of your personal data if it is against
          legitimate interests.
        </li>
        <li>
          <strong>Data erasure or destruction:</strong> You have the right to
          request us to erase, destroy or anonymize your personal data under
          certain conditions.
        </li>
        <li>
          <strong>Suspension:</strong> You can request us to suspend processing
          of your personal data during specific situations.
        </li>
        <li>
          <strong>Rectification:</strong> You have the right to rectify your
          personal data to ensure it is accurate and up to date.
        </li>
        <li>
          <strong>Complaint lodging:</strong> You have the right to complain to
          relevant authorities if your data rights are violated.
        </li>
      </ul>

      <h2 className="text-2xl font-semibold mt-4 text-blue-500">Advertising and Marketing</h2>
      <p className="text-lg mt-2 text-gray-700">
        We may send certain information or newsletter for the purpose of
        utilizing your preference via your email. If you no longer want to
        receive the communications from us, you can click the "unsubscribe" link
        in the email or contact us through our email.
      </p>

      <h2 className="text-2xl font-semibold mt-4 text-blue-500">Cookies</h2>
      <p className="text-lg mt-2 text-gray-700">
        To enrich and perfect your experience, we use cookies or similar
        technologies to display personalized content, appropriate advertising
        and store your preferences on your computer. We use cookies to identify
        and track visitors, their usage of our website and their website access
        preferences. If you do not wish to have cookies placed on your computer
        you should set their browsers to refuse cookies before using our
        website.
      </p>

      <h2 className="text-2xl font-semibold mt-4 text-blue-500">Data Security</h2>
      <p>
        Data Security We endeavor to protect your personal data by establishing
        security measures in accordance with the principles of confidentiality,
        integrity, and availability to prevent loss, unauthorized or unlawful
        access, destruction, use, alteration, or disclosure including
        administrative safeguard, technical safeguard, physical safeguard and
        access controls.
      </p>

      <h2 className="text-2xl font-semibold mt-4 text-blue-500">Data Breach Notification</h2>
      <p className="text-lg mt-2 text-gray-700">
        We will notify the Office of the Personal Data Protection Committee
        without delay and, where feasible, within 72 hours after having become
        aware of it, unless such personal data breach is unlikely to result in a
        risk to the rights and freedoms of you. If the personal data breach is
        likely to result in a high
      </p>

      <h2 className="text-2xl font-semibold mt-4 text-blue-500">
        Changes to this Privacy Policy
      </h2>
      <p className="text-lg mt-2 text-gray-700">
        This Privacy Policy may be updated periodically. Please check our
        website regularly for any updates.
      </p>

      <h2 className="text-2xl font-semibold mt-4 text-blue-500">Contact Information</h2>
      <p className="text-lg mt-2 text-gray-700">
        If you have any questions about this Privacy Policy, please contact:
      </p>
      <ul className="list-disc pl-6">
        <li>
          <strong>Data Controller:</strong> OPTX COMPANY LIMITED, 527/12, 3rd
          Floor, Soi Lay Phrao 94 (Pancha Mit), Phlapphla, Wang Thonglang,
          Bangkok, 10310, Email: chawachai@optx.co.th, Phone: 0907888595
        </li>
        <li>
          <strong>Data Protection Officer:</strong> DPO Team, OPTX COMPANY
          LIMITED, Email: chawachai@optx.co.th, Phone: 0907888595
        </li>
      </ul>

      <p className="text-lg mt-2 text-gray-700">Last updated and effective on 15th July 2024</p>
    </div>
  );
}

export default PrivacyPolicy;
